import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getEmployeeLocalDetails } from "../auth";
import Loading from "./Loading";

const PolicyAcknowledgmentGuard = ({ children }) => {
  const { isAuthenticated, policyStatus, refreshPolicyStatus } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    // Get user role from local storage
    const employeeDetails = getEmployeeLocalDetails();
    setUserRole(employeeDetails?.employee_role);

    // If user is not authenticated, no need to check policies
    if (!isAuthenticated) {
      setIsLoading(false);
      return;
    }

    // If user is admin (role 1), skip policy check
    if (employeeDetails?.employee_role === 1) {
      setIsLoading(false);
      return;
    }

    // If policy status is still loading from AuthContext, wait
    if (policyStatus.loading) {
      return;
    }

    // If we have policy status, use it
    if (policyStatus.lastCheck) {
      setIsLoading(false);
      return;
    }

    // If no policy status yet, trigger a refresh
    refreshPolicyStatus().finally(() => {
      setIsLoading(false);
    });
  }, [isAuthenticated, policyStatus, refreshPolicyStatus]);

  // Show loading while checking policy status
  if (isLoading || policyStatus.loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Loading size="xl" variant="dots" />
      </div>
    );
  }

  // If not authenticated, let PrivateRoute handle the redirect
  if (!isAuthenticated) {
    return children;
  }

  // Skip policy check for admin users (role 1)
  if (userRole === 1) {
    return children;
  }

  // If policies need acknowledgment, redirect to my-policies page
  if (!policyStatus.allAcknowledged && policyStatus.lastCheck) {
    return <Navigate to="my-policies" replace />;
  }

  // All policies acknowledged or no policies to check
  return children;
};

export default PolicyAcknowledgmentGuard;
 